import type { IntermediateFormat } from '../../../../domains/global-filters/model/IntermediateFormat';
import type {
  QueryFormatFilter,
  QueryKeyEnum,
} from '../../../../domains/global-filters/model/QueryFormat';

export function fromUiToQueryFormat<T extends string | number | symbol>(
  uiValue: T,
  queryKey: QueryKeyEnum,
  queryValueByUiValue: Record<T, string>,
): QueryFormatFilter {
  const value = queryValueByUiValue[uiValue];
  if (!value) {
    throw new Error(`Unknown value: ${value}`);
  }
  return { EQUAL: { [queryKey]: value } };
}

export function fromIntermediateToUiFormat<T>(
  intermediateValue: IntermediateFormat,
  uiValueByQueryValue: Record<string, T>,
): T {
  const value = uiValueByQueryValue[intermediateValue.value[0] as string];
  if (value == null) {
    throw new Error(`Unknown value: ${intermediateValue.value[0]}`);
  }
  return value;
}
